(function () {
  var HOLD_MS = 2600; /* time each phrase is fully visible */
  var OUT_MS = 420;   /* must match the CSS exit animation */

  function initField(form) {
    var input = form.querySelector('input[type="search"]');
    var field = form.querySelector('.field');
    if (!input || !field) return;
    if (field.querySelector('.search__rotate')) return;

    var raw = (input.getAttribute('data-rotate-phrases') || '').trim();
    if (!raw) return;
    var phrases = raw.split('|').map(function (p) { return p.trim(); })
      .filter(function (p) { return p.length; });
    if (phrases.length < 2) return;

    var span = document.createElement('span');
    span.className = 'search__rotate';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = phrases[0];
    field.appendChild(span);

    /* Line the overlay up with where the real placeholder renders. */
    var place = function () {
      var fieldBox = field.getBoundingClientRect();
      var inputBox = input.getBoundingClientRect();
      var padLeft = parseFloat(getComputedStyle(input).paddingLeft) || 0;
      span.style.left = (inputBox.left - fieldBox.left + padLeft) + 'px';
    };
    place();
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(field);
    window.addEventListener('resize', place);

    field.classList.add('search-rotate-ready');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var timer = null;

    /* Track focus with our own flag rather than reading document.activeElement,
       which is unreliable when the window itself is not focused. */
    var focused = false;

    var idle = function () {
      return !input.value && !focused;
    };

    var advance = function () {
      if (!idle()) return;
      if (reduce) {
        i = (i + 1) % phrases.length;
        span.textContent = phrases[i];
        return;
      }
      span.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % phrases.length;
        span.textContent = phrases[i];
        span.classList.remove('is-out');
        span.classList.add('is-in');
        setTimeout(function () { span.classList.remove('is-in'); }, OUT_MS);
      }, OUT_MS);
    };

    var start = function () {
      if (timer) return;
      timer = setInterval(advance, HOLD_MS);
    };
    var stop = function () {
      clearInterval(timer);
      timer = null;
    };

    var sync = function () {
      if (idle()) { field.classList.remove('search-rotate-hidden'); start(); }
      else { field.classList.add('search-rotate-hidden'); stop(); }
    };

    input.addEventListener('focus', function () { focused = true; sync(); });
    input.addEventListener('blur', function () { focused = false; sync(); });
    input.addEventListener('input', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('.header__search_desktop .search__form')
      .forEach(initField);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
